import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { useContext } from 'react';
import { ALL_USERS } from '../get-all-users';
// eslint-disable-next-line max-len
import { UserAdministrationModalContext } from '../../../components/brikks/home/UserAdministration/components/UserAdministrationModal/UserAdministrationModalContext';
import { ACTIVE_TAB } from '../../../components/brikks/home/UserAdministration/components/UserAdministrationModal/constants';
import { resendInvitationAPI } from './api';

export function useResendInvitation({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();
  const {
    setActiveTab,
  } = useContext(UserAdministrationModalContext);
  
  const { mutate, isLoading, isSuccess, isError, error } = useMutation(
    (email) => resendInvitationAPI(email),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'resendInvitationSuccess',
          },
        });
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error) => {
        if (error.errorMessage === 'User has already activated their account.') {
          queryClient.invalidateQueries([ALL_USERS, tenantId]);
          setActiveTab(ACTIVE_TAB);
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'warning',
              description: 'resendInvitationAlreadyActivatedError',
            },
          });
        } else {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'resendInvitationError',
            },
          });
        }
      },
    },
  );

  return {
    resendInvitation: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
  };
}
